import { Bar } from '../../render/parts'
import { WasteBin } from '../parts/props'
import type { AssetContext, AssetDefinition } from '../types'

/** Matches the tapered wall of the shared `WasteBin` lathe profile. */
const BASE_R = 0.11
const RIM_R = 0.135
const RIM_Y = 0.32

/** Radius of the bin wall at a given height, pushed 3 mm out so the rib reads. */
function wallRadius(y: number): number {
  return BASE_R + (RIM_R - BASE_R) * Math.min(y / RIM_Y, 1) + 0.003
}

const RIB_COUNT = 12
const RIB_BOTTOM = 0.02
const RIB_TOP = 0.315

/** Vertical wire ribs that turn the plain bin into a mesh one. */
function MeshRibs() {
  return (
    <group>
      {Array.from({ length: RIB_COUNT }, (_, index) => (
        <group key={index} rotation={[0, (index / RIB_COUNT) * Math.PI * 2, 0]}>
          <Bar
            tone="metalDark"
            r={0.004}
            segments={6}
            from={[0, RIB_BOTTOM, wallRadius(RIB_BOTTOM)]}
            to={[0, RIB_TOP, wallRadius(RIB_TOP)]}
          />
        </group>
      ))}
    </group>
  )
}

/** Waste bin. Origin at the centre of the base, y = 0 on the floor. */
function Bin({ variant = 'plain' }: AssetContext) {
  return (
    <group>
      <WasteBin />
      {variant === 'mesh' ? <MeshRibs /> : null}
    </group>
  )
}

export const definition: AssetDefinition = {
  id: 'bin',
  name: 'Papelera',
  category: 'decor',
  footprint: [0.3, 0.3],
  height: 0.35,
  variants: [
    { id: 'plain', name: 'Lisa' },
    { id: 'mesh', name: 'Malla' },
  ],
  keywords: ['papelera', 'basura', 'cesto', 'bin', 'waste', 'trash can'],
  Component: Bin,
}
